import { Component } from "react";
import apis from "../../../../Providers.Api/apis";
import { enableRipple } from "@syncfusion/ej2-base";
import "../../../../styles/css/form.scss";
import Inputbox from "../../../../Components/Inputs/TextInput/Inputbox";
import ConfirmModal from "../../../../Components/Dialogs/ConfirmDialog/ConfirmModal";
import Submenu from "../../../../Components/Layout/Tabs2/SubMenu";
import { Link } from "react-router-dom";
import LoadingOverlay from "../../../../Components/Navigation/LoadingOverlay/LoadingOverlay"
import { convertApiResponseObjectToLower } from "../../../../Common/Helper"
import { appContext } from "../../../../AppContext";
import { rights } from "../../../../Common/RightsManager";
import "../../../../styles/css/dashboard.scss";
import "../../../../App.css";

enableRipple(true);

class EditTaskState extends Component {
  private labels = appContext().labels;
  private local = appContext().localStorageProvider;
  state = {
    isLoadingToSave: false,
    filter: "",
    phoneNumber: null,
    loading: false,
    activePage: 0,
    updates: false,
    identityProviderId: null,
    id: null,
    displayName: null,
    userPreferences: null,
    task_Type_Id: 0,
    task_Type_Name: "",
    eventTypeID: 17,
    task_Type_IsEnabled: 0,
    parentID: "",
    task_State_Id: null,
    task_Category_Id: 0,
    task_Type_Priority: 0,
    task_Type_Resolve_Duration: 0,
    task_IsDefault_Space_Clean_Task: 0,
    task_Type_Priority_Resolve_Duration: 0,
    node_Id: null,
    space_Type: '',
    taskCategoryName: '',
    task_State_Name: null,
    task_State_Header: null,
    task_State_Body: null,
    task_State_Value0: null,
    task_State_Value1: null,
    task_State_L1CTA_P: null,
    task_State_L1CTA_P_Command: null,
    task_State_L1CTA_S: null,
    task_State_L1CTA_S_Command: null,
    task_State_L1CTA_T: null,
    task_State_L1CTA_T_Command: null,
    task_State_Icon: null,
    task_State_Show_Space: 0,
    task_State_Show_Notes: 0,
    task_State_Alternate: null,
    organisationState: "",
    organisationPath: "",
    organisationId: null,
    showOrganisation: false,
    regionState: "",
    regionPath: "",
    regionId: null,
    showRegion: false,
    buildingState: "",
    buildingPath: "",
    buildingId: null,
    showBuilding: false,
    floorState: "",
    floorPath: "",
    floorId: null,
    showFloor: false,
    zoneState: "",
    zonePath: "",
    zoneId: null,
    showZone: false,
    roomState: "",
    roomPath: "",
    roomId: null,
    showRoom: false,
    deskState: "",
    deskPath: "",
    deskId: null,
    showDesk: false,
    spaceFilter: "",
    show: false,
    isDelete: false,
    isUpdateRight: false,
    isDeleteRight: false,
  };

  componentDidMount() {
    const { match, history }: any = this.props;
    if (history.location.state === 'cancel') {
      this.setState({ activePage: 2 });
    }
    this.setState({
      filter: "TaskStates",
      spaceFilter: sessionStorage.getItem('spaceFilter')
    })
    if (match.params.id === "0" && match.params.nodeid) {
      this.setState({
        node_Id: parseInt(match.params.nodeid),
        displayName: "New Task State",
        isUpdateRight: true,
      })
    } else {
      this.getRightList();
      this.setState({
        node_Id: parseInt(match.params.nodeid),
        id: match.params.id,
      }, () => {
        this.getDetails(this.state.id, "TaskStates");
      })
      // match.params.id && this.getDetails(match.params.id, this.state.filter);
    }

  }

  getRightList = () => {

    if (rights.ADMINPORTAL.TaskStates.Update.has()) {
      this.setState({
        isUpdateRight: true
      })
    }
    if (rights.ADMINPORTAL.TaskStates.Delete.has()) {
      this.setState({
        isDeleteRight: true
      })
    }

  }

  getDetails = (id: any, filter: any) => {

    this.setState({ loading: true });
    const node_Id = this.state.node_Id;

    if (sessionStorage.getItem('showOrganisation') === "true") {
      this.setState({
        showOrganisation: true,
        organisationState: sessionStorage.getItem('organisationState'),
        orgnisationnPath: sessionStorage.getItem('orgnisationnPath'),
        organisationId: sessionStorage.getItem('organisationId')
      })
    }

    if (sessionStorage.getItem('showRegion') === "true") {
      this.setState({
        showRegion: true,
        regionState: sessionStorage.getItem('regionState'),
        regionPath: sessionStorage.getItem('regionPath'),
        regionId: sessionStorage.getItem('regionId')
      })
    }

    if (sessionStorage.getItem('showBuilding') === "true") {
      this.setState({
        showBuilding: true,
        buildingState: sessionStorage.getItem('buildingState'),
        buildingPath: sessionStorage.getItem('buildingPath'),
        buildingId: sessionStorage.getItem('buildingId')
      })
    }
    if (sessionStorage.getItem('showFloor') === "true") {
      this.setState({
        showFloor: true,
        floorState: sessionStorage.getItem('floorState'),
        floorPath: sessionStorage.getItem('floorPath'),
        floorId: sessionStorage.getItem('floorId')
      })
    }
    if (sessionStorage.getItem('showZone') === "true") {
      this.setState({
        showZone: true,
        zoneState: sessionStorage.getItem('zoneState'),
        zonePath: sessionStorage.getItem('zonePath'),
        zoneId: sessionStorage.getItem('zoneId')
      })
    }
    if (sessionStorage.getItem('showRoom') === "true") {
      this.setState({
        showRoom: true,
        roomState: sessionStorage.getItem('roomState'),
        roomPath: sessionStorage.getItem('roomPath'),
        roomId: sessionStorage.getItem('roomId')
      })
    }
    if (sessionStorage.getItem('showDesk') === "true") {
      this.setState({
        showDesk: true,
        deskState: sessionStorage.getItem('deskState'),
        deskPath: sessionStorage.getItem('deskPath'),
        deskId: sessionStorage.getItem('deskId')
      })
    }

    apis.getTaskTypesById(node_Id, id, filter).then((res) => {
      const newData = convertApiResponseObjectToLower(res.data)
      this.setState({ ...newData });
      this.setState({
        loading: false,
        displayName: newData.task_State_Id
      });
    }).catch((error: any) => { });
  };
  submit = () => {
    this.setState({ isLoadingToSave: true });
    const { match, history }: any = this.props;
    const { node_Id, id, filter, userPreferences, updates }: any = this.state;

    let payload = {
      "task_State_Id": this.state.task_State_Id,
      "task_State_Name": this.state.task_State_Name,
      "task_State_Header": this.state.task_State_Header,
      "task_State_Body": this.state.task_State_Body,
      "task_State_Value0": this.state.task_State_Value0,
      "task_State_Value1": this.state.task_State_Value1,
      "task_State_L1CTA_P": this.state.task_State_L1CTA_P,
      "task_State_L1CTA_P_Command": this.state.task_State_L1CTA_P_Command,
      "task_State_L1CTA_S": this.state.task_State_L1CTA_S,
      "task_State_L1CTA_S_Command": this.state.task_State_L1CTA_S_Command,
      "task_State_L1CTA_T": this.state.task_State_L1CTA_T,
      "task_State_L1CTA_T_Command": this.state.task_State_L1CTA_T_Command,
      "task_State_Icon": this.state.task_State_Icon,
      "task_State_Show_Space": this.state.task_State_Show_Space,
      "task_State_Show_Notes": this.state.task_State_Show_Notes,
      "task_State_Alternate": this.state.task_State_Alternate
    }

    if (match.params.id === "0") {
      this.create(node_Id, payload);
    } else {
      this.update(node_Id, id, payload);
    }
  };

  create = (nodeId: any, payload: any) => {
    const { history }: any = this.props;
    apis.createTaskStates(payload, nodeId).then((res) => {
      const { history }: any = this.props;
      this.setState({
        updates: true,
        isLoadingToSave: false,
      }, () => {
        history.push("/portfolio-setup-spaces/filter=TaskStates/nodeid=" + res.data.node_Id + "/id=" + res.data.id);
        window.location.reload();
      })
    }).catch((error: any) => {
      this.setState({ isLoadingToSave: false });
    });
  }

  update = (nodeId: any, id: any, payload: any) => {
    const { match, history }: any = this.props;
    const { updates, filter }: any = this.state;
    if (updates) {
      apis.updateSpaceStatesDetails(nodeId, id, filter, payload).then((res) => {
        this.setState({ isLoadingToSave: false });
        history.push("/portfolio-setup-spaces/edit/" + nodeId + "/Building/9");
      }).catch((error: any) => {
        this.setState({ isLoadingToSave: false });
      });
    } else {
      this.setState({ isLoadingToSave: false });
      history.push("/portfolio-setup-spaces/edit/" + nodeId + "/Building/9");
    }
  };

  change = (e: any) => {
    this.setState({ updates: true })
    this.setState({ [e.target.name]: e.target.value });
  };

  isDelete = () => {
    this.setState({
      isDelete: !this.state.isDelete,
      show: !this.state.show,
    })
    this.delete();
  }

  cancelDeleteModal = () => {
    this.setState({
      isDelete: !this.state.isDelete,
      show: !this.state.show,
    })
  }
  delete = () => {
    const { node_Id }: any = this.state;
    const { match }: any = this.props;
    const id = match.params.id;
    if (this.state.isDelete) {
      apis.deleteTaskStatesById(node_Id, id).then((res) => {
        const { history }: any = this.props;
        history.push("/portfolio-setup-spaces/edit/" + node_Id + "/Building/9");
      }).catch((error: any) => { });
    }
  };
  handleModal = () => {
    this.setState({
      show: !this.state.show,
    })
  }

  cancel = () => {
    const { updates, node_Id, buildingId } = this.state
    const { history }: any = this.props;
    if (updates) {
      this.handleModal();
    } else {
      history.push("/portfolio-setup-spaces/edit/" + node_Id + "/Building/9");

    }
  }


  emptyLocalstorage = (filter: any) => {
    if (filter === "Root") {
      // console.log("Root")
      sessionStorage.setItem('showOrganisation', "");
      sessionStorage.setItem('organisationState', "");
      sessionStorage.setItem('orgnisationnPath', '');
      sessionStorage.setItem('organisationId', "");
    }
    if (filter === "Root" || filter === "Region") {
      // console.log("Region")
      sessionStorage.setItem('showRegion', "");
      sessionStorage.setItem('regionState', "");
      sessionStorage.setItem('regionPath', '');
      sessionStorage.setItem('regionId', "");
    }
    if (filter === "Root" || filter === "Region" || filter === "Building") {
      // console.log("Building")
      sessionStorage.setItem('showBuilding', "");
      sessionStorage.setItem('buildingState', "");
      sessionStorage.setItem('buildingPath', '');
      sessionStorage.setItem('buildingId', "");
    }
    if (filter === "Root" || filter === "Region" || filter === "Building" || filter === "Floor") {
      // console.log("Floor")
      sessionStorage.setItem('showFloor', "");
      sessionStorage.setItem('floorState', "");
      sessionStorage.setItem('floorPath', '');
      sessionStorage.setItem('floorId', "");
    }
    if (filter === "Root" || filter === "Region" || filter === "Building" || filter === "Floor" || filter === "Zone") {
      // console.log("Zone")
      sessionStorage.setItem('showZone', "");
      sessionStorage.setItem('zoneState', "");
      sessionStorage.setItem('zonePath', '');
      sessionStorage.setItem('floorId', "");
    }
    if (filter === "Root" || filter === "Region" || filter === "Building" || filter === "Floor" || filter === "Zone" || filter === "Spaces") {
      // console.log("Spaces")
      sessionStorage.setItem('showRoom', "");
      sessionStorage.setItem('roomState', "");
      sessionStorage.setItem('roomPath', '');
      sessionStorage.setItem('roomId', "");
    }
    if (filter === "Root" || filter === "Region" || filter === "Building" || filter === "Floor" || filter === "Zone" || filter === "Spaces" || filter === "Desk") {
      // console.log("Desk")
      sessionStorage.setItem('showDesk', "");
      sessionStorage.setItem('deskState', "");
      sessionStorage.setItem('deskPath', '');
      sessionStorage.setItem('deskId', "");
    }
  }


  linkPath = (data: any) => {
    const { filter } = this.state
    const { history }: any = this.props;

    if (data === "Root") {
      this.setState({
        showOrganisation: false,
        showRegion: false,
        showBuilding: false,
        showFloor: false,
        showZone: false,
        showRoom: false,
        showDesk: false,
        reload: false
      }, () => {
        this.emptyLocalstorage("Root");
        history.push("/portfolio-setup-spaces/edit/" + this.state.organisationId + "/Root");
        // this.getDetails(this.state.organisationId, 'Root');
      })
    }

    if (data === "Region") {
      this.setState({
        showOrganisation: true,
        showRegion: false,
        showBuilding: false,
        showFloor: false,
        showZone: false,
        showRoom: false,
        showDesk: false,
        reload: false
      }, () => {
        this.emptyLocalstorage("Region");
        history.push("/portfolio-setup-spaces/edit/" + this.state.regionId + "/Region");
        // this.getDetails(this.state.regionId, 'Region');
      })

    }

    if (data === "Building") {
      this.setState({
        showOrganisation: true,
        showRegion: true,
        showBuilding: false,
        showFloor: false,
        showZone: false,
        showRoom: false,
        showDesk: false,
        reload: false
      }, () => {
        this.emptyLocalstorage("Building");
        history.push(this.state.buildingPath);
        // this.getDetails(this.state.buildingId, 'Building');
      })

    }

    if (data === "Floor") {
      this.setState({
        showOrganisation: true,
        showRegion: true,
        showBuilding: true,
        showFloor: false,
        showZone: false,
        showRoom: false,
        showDesk: false,
        reload: false
      }, () => {
        this.emptyLocalstorage("Floor");
        history.push(this.state.floorPath);
        // this.getDetails(this.state.floorId, 'Floor');
      })

    }

    if (data === "Zone") {
      this.setState({
        showOrganisation: true,
        showRegion: true,
        showBuilding: true,
        showFloor: true,
        showZone: false,
        showRoom: false,
        showDesk: false,
        reload: false
      }, () => {
        this.emptyLocalstorage("Zone");
        history.push(this.state.zonePath);
        // this.getDetails(this.state.zoneId, 'Zone');
      })
    }

    if (data === "Spaces") {
      this.setState({
        showOrganisation: true,
        showRegion: true,
        showBuilding: true,
        showFloor: true,
        showZone: true,
        showRoom: false,
        showDesk: false,
        reload: false
      }, () => {
        this.emptyLocalstorage("Spaces");
        history.push(this.state.roomPath);
        // this.getDetails(this.state.roomId, 'Spaces');
      })
    }

    if (data === "Desk") {
      this.setState({
        showOrganisation: true,
        showRegion: true,
        showBuilding: true,
        showFloor: true,
        showZone: true,
        showRoom: true,
        showDesk: false,
        reload: false
      }, () => {
        this.emptyLocalstorage("Desk");
        history.push(this.state.deskPath);
        // this.getDetails(this.state.deskId, 'Desk');
      })
    }

  }

  render() {
    const { task_State_Id, task_State_Show_Notes, task_State_Show_Space, task_State_Value1,
      task_State_Value0, task_State_L1CTA_T_Command, task_State_L1CTA_T, task_State_L1CTA_S_Command,
      task_State_L1CTA_S, task_State_L1CTA_P_Command, task_State_L1CTA_P, task_State_Name,
      task_State_Header, task_State_Body, task_State_Icon, task_State_Alternate }: any = this.state;
    const { history }: any = this.props;

    const taskStateIdFld = {
      name: "task_State_Id",
      label: this.labels.HubLabelstateId,
      value: task_State_Id,
      mandatory: true,
      placeholder: this.labels.HubLabelStateIdPlaceholder,
      onchange: this.change,
    }

    const taskStateNameFld = {
      name: "task_State_Name",
      label: this.labels.HubLabelStateName,
      value: task_State_Name,
      mandatory: true,
      placeholder: this.labels.HubLabelStateNamePlaceholder,
      onchange: this.change,
    }

    const taskStateHeaderFld = {
      name: "task_State_Header",
      label: this.labels.HubLabelHeaderText,
      value: task_State_Header,
      placeholder: this.labels.HubLabelHeaderTextPlaceholder,
      onchange: this.change,
    }

    const taskStateBodyFld = {
      name: "task_State_Body",
      label: this.labels.HubLabelBodyText,
      value: task_State_Body,
      placeholder: this.labels.HubLabelBodyTextPlaceholder,
      onchange: this.change,
    }

    const taskStateIconFld = {
      name: "task_State_Icon",
      label: this.labels.HubLabelIcon,
      value: task_State_Icon,
      placeholder: this.labels.HubLabelIconLabelPlaceHolder,
      onchange: this.change,
    }

    const taskStateAlternateFld = {
      name: "task_State_Alternate",
      label: this.labels.HubLabelAlternate,
      value: task_State_Alternate,
      placeholder: this.labels.HubLabelAlternatePlaceholder,
      onchange: this.change,
    }

    const taskStateL1CTAPFld = {
      name: "task_State_L1CTA_P",
      label: this.labels.HubLabelPrimary,
      value: task_State_L1CTA_P,
      mandatory: true,
      placeholder: this.labels.HubLabelprimaryPlaceholder,
      onchange: this.change,
    }

    const taskStateL1CTAPCommandFld = {
      name: "task_State_L1CTA_P_Command",
      label: this.labels.HubLabelPrimaryCommand,
      value: task_State_L1CTA_P_Command,
      mandatory: true,
      placeholder: this.labels.HubLabelPrimaryCommandPlaceholder,
      onchange: this.change,
    }

    const taskStateL1CTASFld = {
      name: "task_State_L1CTA_S",
      label: this.labels.HubLabelSecondary,
      value: task_State_L1CTA_S,
      placeholder: this.labels.HubLabelSecondaryPlaceholder,
      onchange: this.change,
    }

    const taskStateL1CTASCommandFld = {
      name: "task_State_L1CTA_S_Command",
      label: this.labels.HubLabelSecondaryCommand,
      value: task_State_L1CTA_S_Command,
      placeholder: this.labels.HubLabelSecondaryCommandPlaceholder,
      onchange: this.change,
    }

    const taskStateL1CTATFld = {
      name: "task_State_L1CTA_T",
      label: this.labels.HubLabelTertiaryLabel,
      value: task_State_L1CTA_T,
      placeholder: this.labels.HubLabelTertiaryPlaceholder,
      onchange: this.change,
    }

    const taskStateL1CTATCommandFld = {
      name: "task_State_L1CTA_T_Command",
      label: this.labels.HubLabelTertiaryCommand,
      value: task_State_L1CTA_T_Command,
      placeholder: this.labels.HubLabelTertiaryCommandPlaceholder,
      onchange: this.change,
    }

    const taskStateValue0Fld = {
      name: "task_State_Value0",
      label: this.labels.HubLabelvalue0Label,
      value: task_State_Value0,
      mandatory: true,
      placeholder: this.labels.HubLabelValue0Placeholder,
      onchange: this.change,
    }

    const taskStateValue1Fld = {
      name: "task_State_Value1",
      label: this.labels.HubLabelvalue1Label,
      value: task_State_Value1,
      placeholder: this.labels.HubLabelValue1Placeholder,
      onchange: this.change,
    }

    const taskStateShowSpaceFld = {
      name: "task_State_Show_Space",
      label: this.labels.HubLabelShowSpace,
      value: task_State_Show_Space,
      mandatory: true,
      placeholder: this.labels.HubLabelShowSpace,
      onchange: this.change,
    }

    const taskStateShowNotesFld = {
      name: "task_State_Show_Notes",
      label: this.labels.HubLabelShowNotes,
      value: task_State_Show_Notes,
      mandatory: true,
      placeholder: this.labels.HubLabelShowNotes,
      onchange: this.change,
    }

    const props = {
      ...this.props,
      submenu: [
        {
          title: this.labels.HubTabProperties,
          tabNo: 0,
          active: this.state.activePage === 0 ? true : false,
        },
        {
          title: this.labels.HubTabCallToAction,
          tabNo: 1,
          active: this.state.activePage === 1 ? true : false,
        },
        {
          title: this.labels.HubTabVisualSettings,
          tabNo: 2,
          active: this.state.activePage === 2 ? true : false,
        }
      ],
      activePageValue: this.state.activePage,
      childValue: (i: any) => {
        this.setState({ activePage: i });
      },
    };
    const confModalData = this.state.isDelete ? {
      name: this.state.task_State_Name,
      show: this.state.show,
      handleModal: this.cancelDeleteModal,
      okButton: this.delete,
      modalHeading: this.labels.HubLabelConfirmation,
      modalMessage: this.labels.HubLabelDeleteMessage,
    }
      : {
        name: this.state.task_State_Name,
        show: this.state.show,
        handleModal: this.handleModal,
        okButton: () => { history.push("/portfolio-setup-spaces/edit/" + this.state.buildingId + "/Building/9") },
        modalHeading: this.labels.HubLabelConfirmation,
        modalMessage: this.labels.HubLabelConfirmCancelMessage,
      }
    return (
      <>
        {this.state.isLoadingToSave && <LoadingOverlay />}
          <div className="rightPanel">
            <Submenu {...props} />
            <div className="rightPanel-main-content-form">
              {this.state.show ? (
                <ConfirmModal {...confModalData} />
              ) : ""}
              <div className="form-panel">
                {this.state.activePage === 0 && (
                  <div className="main-content">
                    {this.state.loading && (<div className="row">{this.labels.HubLabelLoadingText}</div>)}
                    <div className="form-panel-heading">
                      <div className="form-panel-breadcrumbs">
                        {/* <div className="breadcrumbs"><Link className="breadcrumbs" to={{ pathname: `/portfolio-setup-spaces/edit/` + this.state.node_Id + `/Building` }}>{this.labels.HubTaskStates}</Link></div> */}
                        <div className="breadcrumbs">
                          {this.state.id === 0 ?
                            <Link className="breadcrumbs" to={{ pathname: `/portfolio-setup-spaces/edit/` + this.state.node_Id + `/Building` }}>{this.labels.HubTaskStates}</Link>
                            :
                            <div>
                              <Link className="breadcrumbs" to={{ pathname: `/portfolio-setup-spaces/filter=` + this.state.spaceFilter }}>{this.labels.HubLabelSpaces}</Link>
                              {this.state.showOrganisation && this.state.organisationState != "" && (<Link className="breadcrumbs" to={{ pathname: this.state.organisationPath }} onClick={() => this.linkPath('Root')}> / {this.state.organisationState}</Link>)}
                              {this.state.showRegion && this.state.regionState != "" && (<Link className="breadcrumbs" to={{ pathname: this.state.regionPath }} onClick={() => this.linkPath('Region')}> / {this.state.regionState}</Link>)}
                              {this.state.showBuilding && this.state.buildingState != "" && (<Link className="breadcrumbs" to={{ pathname: this.state.buildingPath }} onClick={() => this.linkPath('Building')}> / {this.state.buildingState}</Link>)}
                              {this.state.showFloor && this.state.floorState != "" && (<Link className="breadcrumbs" to={{ pathname: this.state.floorPath }} onClick={() => this.linkPath('Floor')}> / {this.state.floorState}</Link>)}
                              {this.state.showZone && this.state.zoneState != "" && (<Link className="breadcrumbs" to={{ pathname: this.state.zonePath }} onClick={() => this.linkPath('Zone')}> / {this.state.zoneState}</Link>)}
                              {this.state.showRoom && this.state.roomState != "" && (<Link className="breadcrumbs" to={{ pathname: this.state.roomState }} onClick={() => this.linkPath('Spaces')}> / {this.state.roomState}</Link>)}
                              {this.state.showDesk && this.state.deskState != "" && (<Link className="breadcrumbs" to={{ pathname: this.state.deskState }} onClick={() => this.linkPath('Desk')}> / {this.state.deskState}</Link>)}
                            </div>
                          }

                        </div>
                        <div className="page-title mb-20"><h1>{this.state.displayName}</h1></div>
                      </div>
                    </div>

                    <div className="height-control">
                      {this.state.loading || (
                        <div className="card card-scroller shadow-none">
                          <div className="p-45">
                            <form>

                              <div className="row" >
                                <div className="col-6 pr-2"><Inputbox {...taskStateIdFld} /> </div>
                                <div className="col-6"><Inputbox {...taskStateNameFld} /></div>
                              </div>

                              <div className="row">
                                <div className="col-12"><Inputbox {...taskStateHeaderFld} /></div>
                              </div>

                              <div className="row">
                                <div className="col-12"><Inputbox {...taskStateBodyFld} /></div>
                              </div>

                              <div className="row" >
                                <div className="col-6 pr-2"><Inputbox {...taskStateIconFld} /> </div>
                                <div className="col-6"><Inputbox {...taskStateAlternateFld} /></div>
                              </div>

                            </form>
                          </div>
                        </div>)}
                    </div>
                  </div>
                )}

                {this.state.activePage === 1 && (
                  <div className="main-content">
                    {this.state.loading && (<div className="row">{this.labels.HubLabelLoadingText}</div>)}
                    <div className="form-panel-heading">
                      <div className="form-panel-breadcrumbs">
                        <div className="breadcrumbs"><Link className="breadcrumbs" to={{ pathname: `/portfolio-setup-spaces/edit/` + this.state.node_Id + `/Building` }}>{this.labels.HubTaskStates}</Link></div>
                        <div className="page-title mb-20"><h1>{this.state.displayName}</h1></div>
                      </div>
                    </div>
                    <div className="height-control">
                      {this.state.loading || (
                        <div className="card card-scroller shadow-none">
                          <div className="p-45">
                            <form>

                              <div className="row" >
                                <div className="col-6 pr-2"><Inputbox {...taskStateL1CTAPFld} /> </div>
                                <div className="col-6"><Inputbox {...taskStateL1CTAPCommandFld} /></div>
                              </div>

                              <div className="row">
                                <div className="col-6 pr-2"><Inputbox {...taskStateL1CTASFld} /></div>
                                <div className="col-6"><Inputbox {...taskStateL1CTASCommandFld} /></div>
                              </div>

                              <div className="row">
                                <div className="col-6 pr-2"><Inputbox {...taskStateL1CTATFld} /></div>
                                <div className="col-6"><Inputbox {...taskStateL1CTATCommandFld} /></div>
                              </div>

                              <div className="row" >
                                <div className="col-6 pr-2"><Inputbox {...taskStateValue0Fld} /> </div>
                                <div className="col-6"><Inputbox {...taskStateValue1Fld} /></div>
                              </div>

                            </form>
                          </div>
                        </div>)}
                    </div>
                  </div>
                )}

                {this.state.activePage === 2 && (
                  <div className="main-content">
                    {this.state.loading && (<div className="row">{this.labels.HubLabelLoadingText}</div>)}
                    <div className="form-panel-heading">
                      <div className="form-panel-breadcrumbs">
                        <div className="breadcrumbs"><Link className="breadcrumbs" to={{ pathname: `/portfolio-setup-spaces/edit/` + this.state.node_Id + `/Building` }}>{this.labels.HubTaskStates}</Link></div>
                        <div className="page-title mb-20"><h1>{this.state.displayName}</h1></div>
                      </div>
                    </div>
                    <div className="height-control">
                      {this.state.loading || (
                        <div className="card card-scroller shadow-none">
                          <div className="p-45">
                            <form>

                              <div className="row">
                                <div className="col-6 pr-2"><Inputbox {...taskStateShowSpaceFld} /> </div>
                                <div className="col-6"><Inputbox {...taskStateShowNotesFld} /></div>
                              </div>

                            </form>
                          </div>
                        </div>)}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="rightPanel-main-button-group">
              <div>
                <button className="button-tertiary mr-2" onClick={() => this.cancel()} >{this.labels.HubButtonCancel}</button>
                {(this.state.id !== null && this.state.isDeleteRight === false) && (
                  <button className="button-tertiary-disable mr-2" disabled={true}>{this.labels.HubButtonDelete}</button>
                )}
                {(this.state.id !== null && this.state.isDeleteRight === true) && (
                  <button className="button-tertiary mr-2" onClick={() => this.isDelete()} >{this.labels.HubButtonDelete}</button>
                )}
              </div>
              <div>
                {(task_State_Id === null && task_State_Name === null && this.state.isUpdateRight === false) &&
                  <button className="button-primary-disable ml-2" disabled={true}>{this.labels.HubButtonSave}</button>
                }
                {(task_State_Id !== null && task_State_Name !== null && this.state.isUpdateRight === true) &&
                  <button className="button-primary ml-2" onClick={() => this.submit()}>{this.labels.HubButtonSave}</button>
                }
              </div>
            </div>
          </div>
      </>
    );
  }
}

export default EditTaskState;